import type { QueryClient } from '@tanstack/react-query';
import { redirect } from '@tanstack/react-router';

import { hasPermission } from '@/entities/practice-member';

type PracticeDetailsBeforeLoadArgs = {
    context: { queryClient: QueryClient };
};

export async function practiceDetailsBeforeLoad({ context }: PracticeDetailsBeforeLoadArgs) {
    if (!(await hasPermission(context.queryClient, ['CLINICIAN', 'EHR_BASE']))) {
        throw redirect({ to: '/settings/profile' });
    }
}
